<template>
  <div></div>
</template>
<script>
export default {
  name: "baseModal",
  data() {
    return {
      visible: false,
      waiting: false,
      loading: false,
      cancelLoading: false
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    //modal外部关闭 ，错误回调
    initLoading() {
      this.waiting = false;
      this.cancelLoading = false;
      this.loading = false;
    },
    close() {
      this.initLoading();
      this.visible = false;
    }
  }
};
</script>
